import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }),
};

export const eventsApi = {
  list: () => api.get('/events/admin/list'),   // role-filtered
  listPublic: () => api.get('/events'),
  create: (data) => api.post('/events', data),
  update: (id, data) => api.put(`/events/${id}`, data),
  delete: (id) => api.delete(`/events/${id}`),
};

export const adminsApi = {
  list: () => api.get('/admins'),
  create: (data) => api.post('/admins', data),
  update: (id, data) => api.put(`/admins/${id}`, data),
  delete: (id) => api.delete(`/admins/${id}`),
  assignEvent: (adminId, eventId) => api.post(`/admins/${adminId}/events/${eventId}`),
  removeEvent: (adminId, eventId) => api.delete(`/admins/${adminId}/events/${eventId}`),
};

export const partnersApi = {
  list: (params) => api.get('/partners', { params }),
  create: (data) => api.post('/partners', data),
  update: (id, data) => api.put(`/partners/${id}`, data),
  delete: (id) => api.delete(`/partners/${id}`),
};

export const attractionsApi = {
  list: (params) => api.get('/attractions', { params }),
  create: (data) => api.post('/attractions', data),
  update: (id, data) => api.put(`/attractions/${id}`, data),
  delete: (id) => api.delete(`/attractions/${id}`),
};

export const resultsApi = {
  byEvent: (id) => api.get(`/results/event/${id}`),
  scrape: (id) => api.post(`/results/scrape/${id}`),
  searchFidal: (q) => api.get('/results/fidal/search', { params: { q } }),
};

export default api;
